import createMuiTheme, {
  Theme,
  ThemeOptions,
} from '@material-ui/core/styles/createMuiTheme';
import {
  Palette,
  PaletteOptions,
} from '@material-ui/core/styles/createPalette';

import createMaxWidths, { MaxWidths } from './createMaxWidths';
import * as CustomColors from './colors';

interface CustomSpacing {
  formRow: number;
  navHeight: number;
  navHeightLg: number;
}
interface CustomSpacingOptions {
  formRow?: number;
  navHeight?: number;
  navHeightLg?: number;
}

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    warning: PaletteColor;
    ok: PaletteColor;
    orange: PaletteColor;
    white: PaletteColor;
  }

  // `createMuiTheme`'s parameter, used to customize/extend theme
  interface PaletteOptions {
    ok: PaletteColor;
    orange: PaletteColor;
    white: PaletteColor;
  }
}

declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    maxWidths: MaxWidths;
    palette: Palette;
    customSpacing: CustomSpacing;
  }

  // `createMuiTheme`'s parameter, used to customize/extend theme
  interface ThemeOptions {
    maxWidths?: MaxWidths;
    palette?: PaletteOptions;
    customSpacing?: CustomSpacingOptions;
  }
}

interface Options extends ThemeOptions {
  // we want to make pallete a not optional property
  palette?: PaletteOptions;
}

export function createMyTheme(options: Options): Theme {
  return createMuiTheme({
    maxWidths: createMaxWidths(),
    ...options,
    palette: {
      primary: CustomColors.primary,
      secondary: CustomColors.secondary,
      error: CustomColors.negative,
      grey: CustomColors.grey,
      ok: CustomColors.positive,
      warning: CustomColors.warning,
      orange: CustomColors.orange,
      white: CustomColors.white,
      ...options.palette,
    },
    typography: {
      fontFamily: `'Source Sans Pro', 'Helvetica', 'Arial', 'sans-serif'`, // TODO take it from fonts
      fontSize: 14,
      ...options.typography,
    },
    customSpacing: {
      formRow: 1.4,
      navHeight: 56,
      navHeightLg: 64,
    },
    overrides: {
      MuiCssBaseline: {
        '@global': {
          body: {
            fontSize: '1rem',
            lineHeight: '1.5',
            color: CustomColors.grey[700],
            backgroundColor: CustomColors.white.main,
          },
          img: {
            verticalAlign: 'middle',
          },
          a: {
            color: CustomColors.grey[700],
          },
        },
      },
    },
  });
}

const theme = createMyTheme({});

export default theme;
